import { autoinject, bindable, bindingMode, customElement, DOM } from 'aurelia-framework';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { GroupBase } from 'support/base_classes/group-base';

const DEFAULT_TOOLBAR = { items: ['heading', '|', 'bold', 'italic', '|', 'numberedList', 'bulletedList', '|', 'link', '|', 'undo', 'redo'], shouldNotGroupWhenFull: true };

@autoinject
@customElement('as-form-richtexteditor')
export class RichTextEditor extends GroupBase {
  @bindable({ defaultBindingMode: bindingMode.toView }) options = null;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) value = '';
  @bindable({ defaultBindingMode: bindingMode.toView }) disabled = false;
  @bindable({ defaultBindingMode: bindingMode.fromView }) initialized = false;

  editorPlaceholder: HTMLElement;
  editor;

  constructor(private element: Element) {
    super();
  }

  attached() {
    this.createEditor();
  }

  detached() {
    this.editor?.destroy();
  }

  private async createEditor() {
    const defaultConfiguration = {
      toolbar: DEFAULT_TOOLBAR,
      initialData: this.value !== null ? this.value : ''
    };
    const editorConfiguration = { ...defaultConfiguration, ...this.options };
    this.editor = await ClassicEditor.create(this.editorPlaceholder, editorConfiguration);
    this.editor.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
      if (!isFocused) {
        this.element.dispatchEvent(DOM.createCustomEvent('blur'));
      }
    });
    this.editor.model.document.on('change:data', () => this.value = this.editor.getData());
    this.initialized = true;
    this.disabledChanged(this.disabled);
  }

  disabledChanged(readOnly: boolean) {
    if (this.initialized) {
      if (readOnly)
        this.editor.enableReadOnlyMode('read-only');
      else
        this.editor.disableReadOnlyMode('read-only');
    }
  }
}
